import { Image } from "../../../../atoms/Image";
import { ImageProps } from "../../../../atoms/Image/Image";
import { Video } from "../../../../atoms/Video";
import { VideoProps } from "../../../../atoms/Video/Video";
import { IFrame } from "../../../../molecules/IFrame";
import { IFrameProps } from "../../../../molecules/IFrame/IFrame";

type MainViewImage = {
  component: "image";
  props: ImageProps;
};

type MainViewVideo = {
  component: "video";
  props: VideoProps;
};

type MainViewIFrame = {
  component: "iframe";
  props: IFrameProps;
};

export type MainViewItemProps = {
  /**
   * Determines the entity type loaded. When consuming this, the value you pass to `component` will help infer the available props.
   */
  preset: MainViewImage | MainViewVideo | MainViewIFrame;
  /**
   * If the preset component is an image, this can handle if it is lazy or eagerly loaded.
   */
  shouldPrefetch?: boolean;
};

export const MainViewItem = ({ preset, shouldPrefetch }: MainViewItemProps) => {
  switch (preset.component) {
    case "image": {
      // All images should be lazy loaded by default unless specified otherwise
      return (
        <Image
          {...preset.props}
          data-testid="CarouselImage"
          style={{ ...preset.props.style, width: "100%", height: "100%", objectFit: "cover" }}
          loading={shouldPrefetch ? "eager" : "lazy"}
        />
      );
    }
    case "video": {
      // Any currently playing video should be paused when it is no longer in the MainView
      return <Video {...preset.props} controls onBlur={(e) => e.target.pause()} />;
    }
    case "iframe": {
      return <IFrame {...preset.props} />;
    }
  }
};
